{
  "$id": "cogo:Theme/default-theme-v1",
  "version": "2.0.0",
  "metadata": {
    "name": "Default",
    "description": "Canonical baseline theme — vega style, zinc neutral, default overlays, Geist font.",
    "createdAt": "2026-04-19T00:00:00.000Z"
  },
  "primitives": {
    "colors": {
      "light": {
        "background": "oklch(1 0 0)",
        "foreground": "oklch(0.141 0.005 285.823)",
        "card": "oklch(1 0 0)",
        "card-foreground": "oklch(0.141 0.005 285.823)",
        "popover": "oklch(1 0 0)",
        "popover-foreground": "oklch(0.141 0.005 285.823)",
        "primary": "oklch(0.21 0.006 285.885)",
        "primary-foreground": "oklch(0.985 0 0)",
        "secondary": "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "muted": "oklch(0.967 0.001 286.375)",
        "muted-foreground": "oklch(0.552 0.016 285.938)",
        "accent": "oklch(0.967 0.001 286.375)",
        "accent-foreground": "oklch(0.21 0.006 285.885)",
        "destructive": "oklch(0.577 0.245 27.325)",
        "border": "oklch(0.92 0.004 286.32)",
        "input": "oklch(0.92 0.004 286.32)",
        "ring": "oklch(0.705 0.015 286.067)",
        "chart-1": "oklch(0.871 0.006 286.286)",
        "chart-2": "oklch(0.552 0.016 285.938)",
        "chart-3": "oklch(0.442 0.017 285.786)",
        "chart-4": "oklch(0.37 0.013 285.805)",
        "chart-5": "oklch(0.274 0.006 286.033)",
        "sidebar": "oklch(0.985 0 0)",
        "sidebar-foreground": "oklch(0.141 0.005 285.823)",
        "sidebar-primary": "oklch(0.21 0.006 285.885)",
        "sidebar-primary-foreground": "oklch(0.985 0 0)",
        "sidebar-accent": "oklch(0.967 0.001 286.375)",
        "sidebar-accent-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-border": "oklch(0.92 0.004 286.32)",
        "sidebar-ring": "oklch(0.705 0.015 286.067)"
      },
      "dark": {
        "background": "oklch(0.141 0.005 285.823)",
        "foreground": "oklch(0.985 0 0)",
        "card": "oklch(0.21 0.006 285.885)",
        "card-foreground": "oklch(0.985 0 0)",
        "popover": "oklch(0.21 0.006 285.885)",
        "popover-foreground": "oklch(0.985 0 0)",
        "primary": "oklch(0.92 0.004 286.32)",
        "primary-foreground": "oklch(0.21 0.006 285.885)",
        "secondary": "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "muted": "oklch(0.274 0.006 286.033)",
        "muted-foreground": "oklch(0.705 0.015 286.067)",
        "accent": "oklch(0.274 0.006 286.033)",
        "accent-foreground": "oklch(0.985 0 0)",
        "destructive": "oklch(0.704 0.191 22.216)",
        "border": "oklch(1 0 0 / 10%)",
        "input": "oklch(1 0 0 / 15%)",
        "ring": "oklch(0.552 0.016 285.938)",
        "chart-1": "oklch(0.871 0.006 286.286)",
        "chart-2": "oklch(0.552 0.016 285.938)",
        "chart-3": "oklch(0.442 0.017 285.786)",
        "chart-4": "oklch(0.37 0.013 285.805)",
        "chart-5": "oklch(0.274 0.006 286.033)",
        "sidebar": "oklch(0.21 0.006 285.885)",
        "sidebar-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.488 0.243 264.376)",
        "sidebar-primary-foreground": "oklch(0.985 0 0)",
        "sidebar-accent": "oklch(0.274 0.006 286.033)",
        "sidebar-accent-foreground": "oklch(0.985 0 0)",
        "sidebar-border": "oklch(1 0 0 / 10%)",
        "sidebar-ring": "oklch(0.552 0.016 285.938)"
      }
    },
    "typography": {
      "families": {
        "sans": "\"Geist\", system-ui, sans-serif",
        "mono": "ui-monospace, SFMono-Regular, Menlo, monospace",
        "heading": "\"Geist\", system-ui, sans-serif"
      },
      "scale": {
        "xs": {
          "size": "0.75rem",
          "lineHeight": "1rem"
        },
        "sm": {
          "size": "0.875rem",
          "lineHeight": "1.25rem"
        },
        "base": {
          "size": "1rem",
          "lineHeight": "1.5rem"
        },
        "lg": {
          "size": "1.125rem",
          "lineHeight": "1.75rem"
        },
        "xl": {
          "size": "1.25rem",
          "lineHeight": "1.75rem"
        },
        "2xl": {
          "size": "1.5rem",
          "lineHeight": "2rem"
        },
        "3xl": {
          "size": "1.875rem",
          "lineHeight": "2.25rem"
        },
        "4xl": {
          "size": "2.25rem",
          "lineHeight": "2.5rem"
        }
      },
      "weights": {
        "normal": 400,
        "medium": 500,
        "semibold": 600,
        "bold": 700
      }
    },
    "spacing": {
      "base": "0.25rem",
      "scale": [
        0,
        1,
        2,
        3,
        4,
        6,
        8,
        12,
        16,
        20,
        24,
        32,
        40,
        48,
        56,
        64,
        80,
        96
      ]
    },
    "radius": {
      "base": "0.625rem"
    },
    "elevation": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1)"
    },
    "motion": {
      "duration": {
        "fast": "150ms",
        "base": "200ms",
        "slow": "300ms"
      },
      "ease": {
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    }
  },
  "atoms": {
    "button": {
      "defaultVariant": "default",
      "defaultSize": "default",
      "availableVariants": [
        "default",
        "destructive",
        "outline",
        "secondary",
        "ghost",
        "link"
      ],
      "availableSizes": [
        "default",
        "sm",
        "lg",
        "icon"
      ]
    },
    "input": {
      "defaultVariant": "default",
      "defaultSize": "default",
      "availableVariants": [
        "default"
      ],
      "availableSizes": [
        "default",
        "sm",
        "lg"
      ]
    },
    "textarea": {
      "defaultVariant": "default",
      "defaultSize": "default",
      "availableVariants": [
        "default"
      ],
      "availableSizes": [
        "default"
      ]
    },
    "select": {
      "defaultVariant": "default",
      "defaultSize": "default",
      "availableVariants": [
        "default"
      ],
      "availableSizes": [
        "default",
        "sm",
        "lg"
      ]
    },
    "checkbox": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "switch": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "slider": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "radio": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "label": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "form": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "toggle": {
      "defaultVariant": "default",
      "defaultSize": "default",
      "availableVariants": [
        "default",
        "outline"
      ],
      "availableSizes": [
        "default",
        "sm",
        "lg"
      ]
    },
    "toggle-group": {
      "defaultVariant": "default",
      "defaultSize": "default",
      "availableVariants": [
        "default",
        "outline"
      ],
      "availableSizes": [
        "default",
        "sm",
        "lg"
      ]
    },
    "text": {
      "defaultSize": "base",
      "defaultWeight": "normal"
    },
    "image": {
      "defaultFit": "cover"
    },
    "icon": {
      "defaultSize": "default",
      "availableSizes": [
        "default",
        "sm",
        "lg"
      ]
    },
    "badge": {
      "defaultVariant": "default",
      "availableVariants": [
        "default",
        "secondary",
        "destructive",
        "outline"
      ]
    },
    "avatar": {
      "defaultSize": "default",
      "availableSizes": [
        "default",
        "sm",
        "lg"
      ]
    },
    "alert": {
      "defaultVariant": "default",
      "availableVariants": [
        "default",
        "destructive"
      ]
    },
    "skeleton": {
      "defaultRadius": "md"
    },
    "separator": {
      "defaultVariant": "default",
      "defaultOrientation": "horizontal",
      "availableVariants": [
        "default"
      ]
    },
    "tooltip": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "container": {
      "defaultPadding": "md"
    },
    "card": {
      "defaultRadius": "lg",
      "defaultShadow": "sm",
      "defaultPadding": "md"
    },
    "accordion": {
      "defaultVariant": "single",
      "availableVariants": [
        "single",
        "multiple"
      ]
    },
    "collapsible": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "tabs": {
      "defaultVariant": "default",
      "defaultOrientation": "horizontal",
      "availableVariants": [
        "default"
      ]
    },
    "table": {
      "defaultVariant": "default",
      "availableVariants": [
        "default",
        "striped"
      ]
    },
    "chart": {
      "defaultVariant": "bar",
      "availableVariants": [
        "bar",
        "line",
        "area",
        "composed",
        "pie"
      ]
    },
    "carousel": {
      "defaultVariant": "default",
      "defaultOrientation": "horizontal",
      "availableVariants": [
        "default"
      ]
    },
    "lottie": {},
    "breadcrumb": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "pagination": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "menu": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "navigation": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "dialog": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "sheet": {
      "defaultVariant": "right",
      "availableVariants": [
        "top",
        "right",
        "bottom",
        "left"
      ]
    },
    "popover": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "hover-card": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "dropdown": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "toast": {
      "defaultVariant": "default",
      "availableVariants": [
        "default",
        "destructive"
      ]
    },
    "progress": {
      "defaultVariant": "default",
      "availableVariants": [
        "default",
        "numeric"
      ]
    },
    "loader": {
      "defaultVariant": "default",
      "defaultSize": "default",
      "availableVariants": [
        "default"
      ],
      "availableSizes": [
        "default",
        "sm",
        "lg"
      ]
    },
    "calendar": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "date-picker": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "link": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    },
    "aspect-ratio": {},
    "scroll-area": {
      "defaultVariant": "default",
      "availableVariants": [
        "default"
      ]
    }
  },
  "narrative": {
    "visualTheme": "Neutral, balanced, versatile — the canonical default theme.",
    "agentPromptGuide": "Use for general-purpose UIs without a strong domain identity.",
    "dosAndDonts": {
      "dos": [
        "Lean on default variants"
      ],
      "donts": [
        "Override more than 2 atoms without a reason"
      ]
    }
  },
  "icons": {
    "library": "lucide"
  },
  "i18n": {
    "defaultLocale": "en",
    "supportedLocales": [
      "en"
    ],
    "direction": "ltr"
  }
}
